// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__20tAs","header":"Messages_header__HSzP6"};